import React from "react";
import {
  Layout,
  message,
  Card,
  Row,
  Col, Form,
  Spin, Button, Modal
} from "antd";
import AddAddressDrawer from "../AddAddressDrawer";
import MiCompAPI from "../../../util/api";
import ClientForm from "../Registration/ClientForm";
import EditAddress from "../EditAddress";
import UserAddress from "../UserAddress"

const { Content } = Layout;
class ClientProfile extends React.Component {

  constructor(props) {
    super(props);
    this.state = {

      client: null,
      address_types: [],
      states: [],
      lob: [],
      personalDetailsEditable: false,
      addressEditable: false,
      addAddressActive: false,


    };
    this.api = new MiCompAPI(this.props.userPermandMasters);
  }
  componentDidMount = () => {
    this.signUpForm = Form.create()(ClientForm);

    this.getClient();
    this.getClientMasters();
  };
  addAddressDefaultHandler = () => {
    this.setState({ addAddressActive: !this.state.addAddressActive });
  };
  addAddressSubmitHandler = (data, callback) => {
    data = {
      id: data.id,
      address_Type_Id: data.address_type,
      street: data.street,
      street1: data.street1,
      zipCode: data.zip,
      stateID: data.state,
      city: data.city,
      isprimaryAcc: data.isprimaryAcc,
    };
    message.loading("Adding Address..", 0);
    this.api.invoke(
      "PersonalAddressUpsert",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            message.destroy();
            message.success(data.statusMessage, 3);
            this.setState({ addAddressActive: false });
            this.getClient();
            callback(true);
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
            callback(false);
          }
        } else {
          message.destroy();
          message.error("Add address failed. Contact Support", 3);
          callback(false);
        }
      },
      data
    );
  };
  handleEditStatus = (type) => {
    ;
    if (type === "personal_details")
      this.setState({
        personalDetailsEditable: !this.state.personalDetailsEditable,
      });
    else if (type === "address")
      this.setState({
        addressEditable: !this.state.addressEditable,
      });

  };
  handleEditSubmit = (data) => {

    this.api.invoke(
      "ClientDetailsUpdate",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            message.destroy();
            message.success(data.statusMessage, 3);
            this.setState({
              personalDetailsEditable: !this.state.personalDetailsEditable,
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);

          }
          this.getClient();
        } else {
          message.destroy();
          message.error(
            "Failed to update Personal Details. Contact Support",
            5);
        }
      },
      data
    );

  };
  getClientMasters() {
    this.api.invoke(
      "GetMasters",
      "post",
      (data, success) => {
        if (success) {
          this.setState({
            address_types: data.address_types,
            states: data.states,
            lob: data._lobs,
          });
        }
      },
      ["LOBS", "ADDRESS_TYPE", "STATE",]
    );
  }

  getClient() {
    this.api.invoke(
      "GetClientById/0",
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.setState({
              client: data.data,
            });
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      undefined,
      undefined
    );
  }
  removeAdderss = (address_id) => {
    this.api.invoke(
      "RemovePersonalAddress/" + address_id,
      "delete",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            message.destroy();
            message.success(data.statusMessage, 3);
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
          this.getClient();
        } else {
          message.destroy();
          message.error("Remove address failed. Contact Support", 3);
        }
      }
    );
  }
  getSelectedTabView() {
    if (this.state.isLoading) {
      return (
        <Card
          style={{
            minHeight: "100vh",
            background: "#f0f0f0",
            textAlign: "center",
          }}
        >
          <Spin size="large" />
        </Card>
      );
    }

    let personalDetailsCard, addressCard;
    if (this.state.client) {
      if (this.state.personalDetailsEditable) {
        personalDetailsCard = (
          <div className="mi_main">
            <Row span={24}>
              <Col span={15}>
                <p className='mi_title' style={{ color: '#fd828d' }}> Company Details  </p>
              </Col>
              <Col span={9}>
                <Button className="mi_button_icon" onClick={this.handleEditStatus.bind(this, "personal_details")} > <i className="fa fa-times mi_icon mi_icon_red" ></i></Button>
              </Col>
            </Row>
            <this.signUpForm lob={this.state.lob} isexistprofile={true} states={this.state.states} loa_id={this.state.client.loa_id} data={this.state.client.client} id={this.state.client.client.user_id} submitHandler={this.handleEditSubmit} />
          </div>
        );
      } else {
        personalDetailsCard = (
          <div className="mi_main">
            <Row span={24}>
              <Col span={18}>
                <p className='mi_title' style={{ color: '#fd828d' }}>Company Details  </p>
              </Col>
              <Col span={6}>
                <Button className="mi_button_icon" onClick={this.handleEditStatus.bind(this, "personal_details")} > <i className="fa fa-pencil mi_icon" /></Button>

              </Col>
            </Row>
            <Row>
              <Col md={5} sm={24}>
                <p className="mi_name">Company Name</p>
                <p className="mi_value">{
                  (this.state.client.client.client_name ? this.state.client.client.client_name : "none")
                }</p>
              </Col>
              <Col md={5} sm={24}>
                <p className="mi_name">Primary Contact Name</p>
                <p className="mi_value">{
                  (this.state.client.client.primary_Contact_First_Name
                    ? this.state.client.client
                      .primary_Contact_First_Name
                    : "") +
                  " " +
                  (this.state.client.client.primary_Contact_Middle_Name
                    ? this.state.client.client
                      .primary_Contact_Middle_Name
                    : "") +
                  " " +
                  (this.state.client.client.primary_Contact_Last_Name
                    ? this.state.client.client.primary_Contact_Last_Name
                    : "")
                }</p> </Col>



              <Col md={5} sm={24}>
                <p className="mi_name">Email</p>
                <p className="mi_value">{(this.state.client.client && this.state.client.client.email) ? this.state.client.client.email : "None"}</p>
              </Col>
              <Col md={5} sm={24}>
                <p className="mi_name"> Contact Number</p>
                <p className="mi_value">
                  {this.state.client.client.primary_Contact_Phone &&
                    this.state.client.client.primary_Contact_Phone.length === 17 ? (<a href={"tel:+" + this.state.client.client.primary_Contact_Phone}>
                      {this.state.client.client.primary_Contact_Phone}
                    </a>
                  ) : (
                    "Invalid US Number"
                  )
                  }
                </p>
              </Col>

              <Col md={4} sm={24}>
                <p className="mi_name">Tax Id</p>
                <p className="mi_value">{(this.state.client.client && this.state.client.client.client_tax_id) ? (this.state.client.client.client_tax_id.length === 10 ? this.state.client.client.client_tax_id : "Invalid Tax Id") : "None"}</p>
              </Col>

            </Row>
            <hr />
            <Row span={24}>
              <Col span={6}>
                <p className='mi_title' style={{ color: '#fd828d' }}>LOA  </p>
              </Col>
              <Col span={24} style={{ display: 'flex' }}>
                {
                  this.state.client && this.state.client.loas ? this.state.client.loas.map((iteam, index) => {
                    if (this.state.client.loas.length - 1 === index) {
                      return (<>
                        <p className="mi_value">{iteam}.</p>
                      </>)
                    } else {
                      return (<>
                        <p className="mi_value">{iteam},</p>
                      </>)
                    }

                  })
                    : "None"}
              </Col>
            </Row>
          </div>
        );
      }
      if (this.state.addressEditable) {
        addressCard = (
          <div className="mi_main">
                      <Row span={24}>
                        <Col span={15}>
                          <p className='mi_title' style={{ color: '#fd828d' }}>Address</p>
                        </Col>
                        <Col span={9}>
                          <Button className="mi_button_icon" onClick={this.handleEditStatus.bind(this, "address")}   > {this.state.addressEditable ?
                            <i className="fa fa-times mi_icon mi_icon_red" />
                            :
                            <i className="fa fa-pencil mi_icon" />}
                          </Button>
                          <Button className="mi_button_icon" onClick={this.addAddressDefaultHandler}> <i className="fa fa-plus mi_icon" /></Button>
                        </Col>
                      </Row>

            {this.state.client && this.state.client.address
              ? this.state.client.address.map((item) => {
                return (
                  <div>
                      <p className='mi_address_card'>{item.address_Type_Name}</p>
                      <EditAddress item={item} states={this.state.states} removeAdderss={this.removeAdderss} submitHandler={this.addAddressSubmitHandler}></EditAddress>
                  </div>
                );
              }) : ''}
      </div>
        );
      }
      else {
        addressCard = (
          <div className="mi_main">
            <Row span={24}>
              <Col span={15}>
                <p className='mi_title' style={{ color: '#fd828d' }}>Address</p>
              </Col>
              <Col span={9}>
                <Button className="mi_button_icon" onClick={this.handleEditStatus.bind(this, "address")}   > {this.state.addressEditable?
                   <i className="fa fa-times mi_icon mi_icon_red" />
                   :
                   <i className="fa fa-pencil mi_icon" />}
                </Button>
                <Button className="mi_button_icon" onClick={this.addAddressDefaultHandler}> <i className="fa fa-plus mi_icon" /></Button>
              </Col>
            </Row>
          <UserAddress address={this.state.client.address}></UserAddress>
          </div>
        );
      }
    }

    return (
      <Row span={24}>
        <Row span={24}>
          <Col md={24} sm={24}>{personalDetailsCard}</Col>
        </Row>



        <Row span={24}>
          <Col md={24} sm={24}>{addressCard}</Col>
        </Row>
      </Row>
    );

  }
  render() {
    return (
      <Content>
        {this.state.addAddressActive ? (
          <Modal
            visible={this.state.addAddressActive}>
            <AddAddressDrawer
              closeDrawerHandler={this.addAddressDefaultHandler}
              submitHandler={this.addAddressSubmitHandler}
              width={500}
              address_types={this.state.address_types}
              states={this.state.states}
              userPermandMasters={this.props.userPermandMasters}
              title="Enter New Address Details"
            />
          </Modal>
        ) : null}
        <div className="mi_main_div">
          {this.getSelectedTabView()}
        </div>
      </Content>
    );
  }
}
export default ClientProfile;
